var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"height":"24","width":"24","xmlns":"http://www.w3.org/2000/svg"}},_vm.$listeners),[_c('path',{attrs:{"d":"M21 3a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2zm-1.659 2.247L12 11.671 4.659 5.247a1 1 0 1 0-1.317 1.506l7.341 6.423a2 2 0 0 0 2.634 0l7.341-6.423a1 1 0 1 0-1.317-1.506z","fill-rule":"evenodd"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }